<template>
  <v-row class="pl-1">
    <v-col>
      <v-tabs
        v-model="userTab"
        show-arrows
        class="user-tabs"
        grow
      >
        <v-tab
          v-for="tab in tabs"
          :key="tab.title"
        >
          <v-icon
            size="20"
            class="me-3"
          >
            {{ tab.icon }}
          </v-icon>
          <span>{{ tab.title }}</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items
        id="user-tabs-content"
        v-model="userTab"
        class="mt-5"
      >
        <div style="min-height: 4px">
          <v-progress-linear
            v-if="loading"
            indeterminate
          />
        </div>

        <v-tab-item>
          <v-row>
            <v-col
              cols="12"
              sm="3"
            >
              <div class="d-flex justify-center title font-weight-light">
                Selecione uma árvore
              </div>

              <div class="d-flex justify-end">
                <v-btn
                  class="ml-2 mt-4 mb-2"
                  color="success"
                  @click="criarArvore()"
                >
                  <v-icon>
                    {{ icons.mdiPlus }}
                  </v-icon>
                  <span>Criar árvore</span>
                </v-btn>
              </div>

              <v-list>
                <v-list-item-group
                  v-model="arvoreAtiva"
                  active-class="chat-ativo white--text active-chat-contact"
                >
                  <div
                    v-for="(arvore, index) in arvores"
                    :key="index"
                  >
                    <v-list-item
                      class="mb-2"
                      @click="getArvoreData(arvore)"
                    >
                      <v-list-item-content>
                        <v-list-item-title>{{ arvore.nome }}</v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action
                        v-if="!arvore.principal"
                      >
                        <v-tooltip
                          top
                          color="primary"
                        >
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-icon
                              v-bind="attrs"
                              class="cursor-pointer"
                              color="primary"
                              v-on="on"
                              @click.stop="deletarArvore(arvore)"
                            >
                              {{ icons.mdiTrashCanOutline }}
                            </v-icon>
                          </template>
                          <span>Deletar árvore</span>
                        </v-tooltip>
                      </v-list-item-action>
                    </v-list-item>

                    <v-divider
                      v-if="index < arvores.length - 1"
                      :key="index"
                      class="mb-2"
                    />
                  </div>
                </v-list-item-group>
              </v-list>
            </v-col>

            <v-divider :vertical="$vuetify.breakpoint.name === 'xs' ? false : true"></v-divider>

            <v-col
              cols="12"
              sm="9"
            >
              <v-scroll-y-transition mode="out-in">
                <v-card
                  v-if="arvorePrincipalAtiva"
                  flat
                  class="d-flex align-center justify-center flex-column"
                >
                  <v-card-title class="d-flex justify-center">
                    <span class="title font-weight-semibold overflow-auto">
                      A árvore principal já foi configurada durante a criaçao do bot.
                    </span>
                    <span class="title font-weight-semibold overflow-auto">
                      Para continuar a configuração clique em ⚙️ CONFIGURAÇÃO DAS OPÇÕES ou no botão abaixo.
                    </span>
                  </v-card-title>

                  <v-btn
                    color="primary"
                    @click="userTab = 1"
                  >
                    Ir para configuração das opções
                  </v-btn>
                </v-card>

                <v-stepper
                  v-else
                  v-model="activeStep"
                  vertical
                  class="custom-header"
                  non-linear
                  flat
                >
                  <v-form
                    ref="formRef"
                    class="multi-col-validation"
                    @submit.prevent="handleSubmit"
                  >
                    <v-col
                      col="12"
                      sm="12"
                    >
                      <v-stepper-step
                        editable
                        :complete="activeStep > 1"
                        step="1"
                      >
                        <div class="d-flex align-center">
                          <span class="text--primary text-4xl font-weight-bold me-3">01</span>
                          <div class="d-flex flex-column">
                            <span class="text--primary text-sm font-weight-semibold">Nome</span>
                            <span class="text--secondary text-xs">Escolha o nome da árvore</span>
                          </div>
                        </div>
                      </v-stepper-step>

                      <v-stepper-content step="1">
                        <v-col
                          cols="12"
                        >
                          <v-text-field
                            v-model="arvoreData.nome"
                            label="Nome"
                            dense
                            outlined
                            :rules="[validators.required]"
                          />

                          <v-btn
                            color="primary"
                            @click="nextStep"
                          >
                            Próximo
                          </v-btn>
                        </v-col>
                      </v-stepper-content>

                      <v-stepper-step
                        :complete="activeStep > 2"
                        editable
                        step="2"
                      >
                        <div class="d-flex align-center">
                          <span class="text--primary text-4xl font-weight-bold me-3">02</span>
                          <div class="d-flex flex-column">
                            <span class="text--primary text-sm font-weight-semibold">Descrição</span>
                            <span class="text--secondary text-xs">Descreve a função dessa árvore</span>
                          </div>
                        </div>
                      </v-stepper-step>

                      <v-stepper-content step="2">
                        <v-col
                          cols="12"
                        >
                          <v-textarea
                            v-model="arvoreData.mensagemInicial"
                            label="Mensagem Inicial da Árvore"
                            dense
                            outlined
                            auto-grow
                            rows="3"
                            row-height="10"
                            validate-on-blur
                            :rules="[validators.required]"
                          />

                          <div
                            class="mt-2"
                          >
                            <v-btn
                              outlined
                              class="mr-2"
                              @click="previousStep"
                            >
                              Anterior
                            </v-btn>
                            <v-btn
                              color="primary"
                              @click="nextStep"
                            >
                              Próximo
                            </v-btn>
                          </div>
                        </v-col>
                      </v-stepper-content>

                      <v-stepper-step
                        :complete="activeStep > 3"
                        editable
                        step="4"
                      >
                        <div class="d-flex align-center">
                          <span class="text--primary text-4xl font-weight-bold me-3">03   </span>
                          <div class="d-flex flex-column">
                            <span class="text--primary text-sm font-weight-semibold">Pesquisa de satisfação</span>
                            <span class="text--secondary text-xs">Configura a árvore para ser uma pesquisa de satisfação</span>
                          </div>
                        </div>
                      </v-stepper-step>

                      <v-stepper-content step="3">
                        <v-col
                          cols="12"
                        >
                          <v-checkbox
                            v-model="arvoreData.pesquisaDeSatisfacao"
                            label="Árvore para pesquisa de satisfação?"
                            class="mx-4"
                          />
                          <v-btn
                            outlined
                            class="mt-2"
                            @click="previousStep"
                          >
                            Anterior
                          </v-btn>
                        </v-col>
                      </v-stepper-content>

                      <div class="d-flex justify-center flex-wrap gap-4 mt-2">
                        <v-btn
                          outlined
                          @click="resetForm"
                        >
                          Cancelar
                        </v-btn>

                        <v-btn
                          color="success"
                          class="ms-2"
                          :loading="loadingSubmit"
                          type="submit"
                        >
                          {{ arvoreData.id ? 'Salvar' : 'Criar' }}
                        </v-btn>
                      </div>
                    </v-col>
                  </v-form>
                </v-stepper>
              </v-scroll-y-transition>
            </v-col>
          </v-row>
        </v-tab-item>

        <v-tab-item>
          <arvore-view
            v-if="chatBotId"
            :arvore-id.sync="arvoreId"
            :chat-bot-id.sync="chatBotId"
            :is-arvore-escolhida-pesquisa-satisfacao="isArvoreEscolhidaPesquisaSatisfacao"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import Vue from 'vue'
import { computed, ref, watch, watchEffect, onBeforeMount } from '@vue/composition-api'
import { mdiCogOutline, mdiTrashCanOutline, mdiPlus } from '@mdi/js'
import { required } from '@/@core/utils/validation'
import ArvoreView from './arvore/ArvoreView.vue'
import ChatBotService from '@/services/modules/ChatBotService'
import { EventBus } from '@/utils/EventBus'

export default {
  components: {
    ArvoreView,
  },

  props: {
    chatBotId: {
      type: Number,
      required: true,
    },
    arvoreId: {
      type: Number,
      default: null,
      required: false,
    },
  },

  setup(props, { emit }) {
    const blankArvoreData = {
      nome: '',
      mensagemInicial: '',
      pesquisaDeSatisfacao: false,
    }
    const arvoreEscolhidaId = ref(null)

    watch(() => props.arvoreId, value => {
      arvoreEscolhidaId.value = value
    }, { immediate: true, deep: true })

    const arvoreAtiva = ref(0)
    const arvores = ref([])
    const activeStep = ref(1)
    const arvorePrincipalAtiva = ref(false)
    const arvoreData = ref(JSON.parse(JSON.stringify(blankArvoreData)))

    const isArvoreEscolhidaPesquisaSatisfacao = computed(() => arvores.value.find(it => it.id === arvoreEscolhidaId.value)?.pesquisaDeSatisfacao)

    async function getArvores() {
      const resGetArvore = await ChatBotService.getArvoresDisponiveis(props.chatBotId)
      if (resGetArvore.length > 0) {
        arvores.value = resGetArvore
      }
    }

    async function getArvorePrincipal() {
      arvoreAtiva.value = 0
      arvores.value.forEach(element => {
        if (element.principal) {
          arvoreEscolhidaId.value = element.id
          emit('update:arvore-id', arvoreEscolhidaId.value)
          EventBus.$emit('nome-arvore', 'Principal')
          arvorePrincipalAtiva.value = true
        }
      })
    }

    onBeforeMount(async () => {
      await getArvores()
      await getArvorePrincipal()
    })

    function getArvoreData(element) {
      arvorePrincipalAtiva.value = !!element.principal
      arvoreData.value = element
      arvoreEscolhidaId.value = element.id
      const { nome } = element
      EventBus.$emit('nome-arvore', nome)
      emit('update:arvore-id', element.id)
    }

    function criarArvore() {
      arvorePrincipalAtiva.value = false
      arvoreData.value = []
      arvoreEscolhidaId.value = 0
      activeStep.value = 1
    }

    const formRef = ref(null)
    const loadingSubmit = ref(false)

    const idBot = ref(null)

    const isArvoreNova = computed(() => !arvoreData.value.id)

    async function resetForm() {
      formRef.value.reset()
      await getArvores()
      await getArvorePrincipal()
    }

    watchEffect(async () => {
      if (props.chatBotId) {
        await getArvores()
        activeStep.value = 3
      }
    })

    function getRequestBody() {
      return { ...arvoreData.value }
    }

    async function createArvore() {
      try {
        loadingSubmit.value = true
        const data = await ChatBotService.criarArvore(props.chatBotId, getRequestBody())
        arvoreEscolhidaId.value = data.id
        loadingSubmit.value = false
        await getArvores()

        emit('update:arvore-id', arvoreEscolhidaId.value)
      } catch {
        loadingSubmit.value = false
      }
    }

    async function updateArvore() {
      const req = getRequestBody()
      try {
        loadingSubmit.value = true
        await ChatBotService.atualizarArvore(props.chatBotId, req.id, req)
        loadingSubmit.value = false
        await getArvores()

        emit('update:arvore-id', req.id)
      } catch {
        loadingSubmit.value = false
      }
    }

    async function handleSubmit() {
      if (loadingSubmit.value) return
      if (formRef.value.validate()) {
        if (isArvoreNova.value) {
          await createArvore()
        } else {
          await updateArvore()
        }
      } else {
        Vue.$toast.warning('Preencha os dados corretamente.')
      }
    }

    async function deletarArvore(element) {
      try {
        await ChatBotService.deletarArvore(props.chatBotId, element.id)
        getArvores()
        // resetDataAndCloseDialog()
      } catch {
        // NAO FAZ NADA CASO DÊ ERRO
      }
    }

    function nextStep() {
      // eslint-disable-next-line no-plusplus
      activeStep.value++
    }

    function previousStep() {
      // eslint-disable-next-line no-plusplus
      activeStep.value--
    }

    const tabs = [
      { icon: mdiCogOutline, title: 'Dados da Árvore' },
      { icon: mdiCogOutline, title: 'Configuração das opções' },
    ]
    const userTab = ref(0)
    const loading = ref(false)

    return {
      tabs,
      userTab,
      loading,
      activeStep,
      nextStep,
      previousStep,
      idBot,
      formRef,
      resetForm,
      arvoreAtiva,
      arvores,
      arvoreData,
      loadingSubmit,
      arvorePrincipalAtiva,
      isArvoreEscolhidaPesquisaSatisfacao,
      handleSubmit,
      getArvoreData,
      criarArvore,
      deletarArvore,
      icons: {
        mdiCogOutline,
        mdiTrashCanOutline,
        mdiPlus,
      },
      validators: {
        required,
      },
    }
  },
}
</script>
